/* eslint-disable react/jsx-wrap-multilines */
import React, {useEffect, useRef, useState} from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import {
    Button,
    TextField,
    CircularProgress, DialogTitle, DialogActions, Dialog, DialogContent, Autocomplete, Stack, Tooltip, IconButton
} from '@mui/material';
import {Box, Grid, ListItemText, MenuItem, Typography} from "@mui/material";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {VersOre, MinordList,OpzioniList, LuoghiList} from "./types";
import {useCreateVersOre, useGetProgettiByDip, useGetAttivita, useGetNodi,validationSchemaVersOre} from "./Services";
import {format} from "date-fns";
import ReportProg from "../reports/ReportProg";
import EditIcon from '@mui/icons-material/Edit';
import SummarizeIcon from '@mui/icons-material/Summarize';
import {InferType} from "yup";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "./VersOreNoteAssist";


interface AddVersOreProps {
  onClose: () => void;
}

// const AddVersOre  = ()  => {
const AddVersOre: React.FC<AddVersOreProps> = ({ onClose }) => {



  const today = format(new Date(), 'yyyy-MM-dd');

  const [idprog, setIdProg] = useState('NN');
  const [idnodo, setIdNodo] = useState('NN');
  const [idatt, setIdAtt] = useState('NN');

  const [codprog, setCodProg] = useState('');
  const [codnodo, setCodNodo] = useState('');
  const [codatt, setCodAtt] = useState('');

  const [tiponodo, setTipoNodo] = useState('');
  
  const [ditta, setDitta] = useState(0);

const [openReport, setOpenReport] = useState(false);

const [molt, setMolt] = useState<number>(1);

  const [datareg, setDataReg] = useState('');
  const [datains, setDataIns] = useState('');

  const [minord, setMinOrd] = useState(0);

  const [opzione, setOpzione] = useState('');

  const { mutateAsync: createVersOre, isPending: isCreatingVersOre } = useCreateVersOre();

  const {  data: ProgettiApiResponse } = useGetProgettiByDip();
  const {  data: NodiApiResponse , refetch: refetchNodi  } = useGetNodi(idprog);
  const {  data: AttivitaApiResponse , refetch: refetchAttivita  } = useGetAttivita(idprog);

  type VersOreForm = InferType<typeof validationSchemaVersOre>;

  const { setValue, register,control, handleSubmit, formState: { errors },reset,watch} = useForm<VersOreForm>({
  resolver: yupResolver(validationSchemaVersOre),
  defaultValues: {
    luogo: 'SEDE',
  },
});


const watchLuogo = watch('luogo');
const watchIdProg = watch('idprog');

const watchOreStraord = watch('orestraord');
const watchMinStraord = watch('minstraord');

useEffect(() => {
  const ore = Number(watchOreStraord) || 0;
  const minuti = Number(watchMinStraord) || 0;
 const moltiplicatore = molt || 1;

  // console.log(molt);

  // 1️⃣ Converto tutto in minuti
  const minutiTotali = (ore * 60 + minuti) * moltiplicatore;

  // 2️⃣ Converto in ore arrotondate per eccesso
  let oreCalcolate = Math.ceil(minutiTotali / 60);

  // 3️⃣ Regola TRASFERTA applicata DOPO il calcolo
  if (watchLuogo === 'TRASFERTA') {
    oreCalcolate = oreCalcolate <= 4 ? 4 : 8;
  }

  setValue('oreord', oreCalcolate);
}, [watchOreStraord, watchMinStraord, watchLuogo, molt, setValue]);

  useEffect(() => {
    // console.log("✅ idprog changed:", idprog);

    if (idprog) {
        // console.log("🔄 Calling refetchNodi() and refetchAttivita()");
        refetchNodi();
        refetchAttivita();
        setIdNodo('NN');
        setIdAtt('NN');
        setCodNodo('');
        setCodAtt('');
        setTipoNodo('');
        setValue('idnodo', '');
        setValue('idatt', '');

    } else {
        // console.warn("⚠️ idprog is empty, skipping refetch");
    }
}, [idprog]);  // Ensure this runs when `idprog` changes


    useEffect(() => {
        setValue('orestraord', 0);
        setValue('minstraord', 0);
        setValue('km', 0);
        setValue('trasf', 0);
    }, [setValue]);



  const clickedButtonRef = useRef<string | null>(null);



const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
    // console.log('handleSelection called with:', value);
    if (value) {
          // console.log('Setting field:', fieldName, 'with value:', value);
        setValue(fieldName, value);
        setter(value);
    }
    // console.log('values of form ', watch());
};



  const handleButtonClick = (buttonId: string) => {
        clickedButtonRef.current = buttonId;
      };


 const onSubmit: SubmitHandler<VersOre> = async (data) => {

      if (clickedButtonRef.current === 'save') {
           const copilotConfig = await loadVersOreCopilotConfig();
           data.indlavoraz = 0;
           data.indora = 0;
           data.indtipovers = 2;
           data.valutadqr = 'EURO';
           data.umtempodqr = 2;
           data.indtipocosdqr = 0;
           data.costodqr = 30;
           data.impdqr = 90;
           data.protocollo = 1037;
           data.coddip = localStorage.getItem('coddip') || '';
           data.minord = 0;
           data.note = clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value;

           switch (tiponodo) {
            case 'FATTMANNO': data.opzione = 'FATTMAN';   break;
            case 'FATTNODO': data.opzione = 'FATT'; break;
            case 'NOFATTNODO': data.opzione = 'NOFATT'; break;
            case 'PREPNODO': data.opzione = 'PREP'; break;
            case 'PREPNORI': data.opzione = 'PREPRI'; break;
            case 'PREPNOUT': data.opzione = 'PREPUT'; break;
            case 'SOSPNODO': data.opzione = 'SOSP'; break;
            case 'NA': data.opzione = ''; break;
            default: data.opzione = ''; // Set a default value if needed
        }



           await createVersOre(data);
           onClose();
       }
   };

 const handleClose = () => {
            onClose();
          };

  return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
    <>
    <Dialog onClose={onClose} open fullWidth maxWidth="sm">
         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="h5">Nuovo</Typography>
                          {codprog && (
                              <Tooltip title="Report Nodi Progetto" arrow>
                                  <IconButton
                                    size="large"
                                    color="primary"
                                    onClick={() => setOpenReport(true)}
                                  >
                                    <SummarizeIcon sx={{ fontSize: 30 }} />
                                  </IconButton>
                              </Tooltip>
                                )}

            </DialogTitle>
        <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={0.5} direction="column" alignItems="flex-start">

                {/* First Row: First Four Fields */}
                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                    <Box sx={{ width: '33.33%' }}>
                        <TextField id="datareg" type="date" label="Data" fullWidth margin="dense" defaultValue={today} {...register('datareg')} />
                        <Typography variant="inherit" color="error">{errors.datareg?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '33.33%' }}>
                        <TextField id="datains" type="date" label="Data Ins." fullWidth margin="dense" defaultValue={today} disabled  {...register('datains')} />
                        <Typography variant="inherit" color="error">{errors.datains?.message}</Typography>
                    </Box>

                     <Box sx={{ width: '33.33%' }}>
                        <Autocomplete
                        disablePortal
                        id="opzione"
                        // value={opzione}
                        options={OpzioniList}
                        disabled
                        onChange={(event, value) => {handleSelection(setOpzione, 'opzione', value?.id)}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Opzione" fullWidth />}
                        />
                        <Typography variant="caption" color="error">{errors.opzione?.message}</Typography>
                  </Box>

                </Stack>

                {/* Next fields: Remaining fields */}
                <Box sx={{ width: '100%' }}>
                    <Autocomplete
                        disablePortal
                        id="idprog"
                       // value={ProgettiApiResponse?.results.find((item) => item.idprog === idprog) || null}
                        options={ProgettiApiResponse?.results ?? []}
                        onChange={(event, value) => {handleSelection(setIdProg, 'idprog', value?.idprog);handleSelection(setMolt, 'molt', parseFloat(String(value?.molt).replace(',', '.')));handleSelection(setCodProg, 'codprog', value?.codprog);handleSelection(setDitta, 'ditta', value?.ditta);}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Progetto" fullWidth />}
                    />
                        <Typography variant="caption" color="error">{errors.idprog?.message}</Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Autocomplete
                        disablePortal
                        id="idnodo"
                        value={NodiApiResponse?.results.find((item) => item.idnodo === idnodo) || null}
                        options={NodiApiResponse?.results ?? []}
                        onChange={(event, value) => {handleSelection(setIdNodo, 'idnodo', value?.idnodo);handleSelection(setTipoNodo, 'tiponodo', value?.tiponodo);handleSelection(setCodNodo, 'codnodo', value?.codnodo);}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Nodo" fullWidth />}
                    />
                     <Typography variant="caption" color="error">{errors.idnodo?.message}</Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Autocomplete
                        disablePortal
                        id="idatt"
                        value={AttivitaApiResponse?.results.find((item) => item.idatt === idatt) || null}
                        options={AttivitaApiResponse?.results ?? []}
                        onChange={(event, value) => {handleSelection(setIdAtt, 'idatt', value?.idatt);handleSelection(setCodAtt, 'codatt', value?.codatt);}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Attivita" fullWidth />}
                    />
                    <Typography variant="caption" color="error">{errors.idatt?.message}</Typography>
                </Box>

                {/* Continue with the rest of the fields as they were */}
              {/* Second Row: Oreord, Minord, Opzione */}
                 <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                    <Box sx={{ width: '33.33%' }}>
                        <TextField id="orestraord" label="Ore Eff" fullWidth margin="dense" {...register('orestraord')} error={!!errors.oreord} />
                        <Typography variant="caption" color="error">{errors.orestraord?.message}</Typography>
                    </Box>
                   <Controller
                              name="minstraord"
                              control={control}
                              defaultValue={0}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  options={MinordList}
                                  getOptionLabel={(option) => option.label}
                                  value={
                                    MinordList.find((opt) => opt.id === field.value) || null
                                  }
                                  onChange={(_, value) => {
                                    field.onChange(value ? value.id : 0);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} margin="dense" label="Min Eff" fullWidth />
                                  )}
                                />
  )}
/>
                     <Box sx={{ width: '33.33%' }}>
                        <TextField id="oreord" label="Ore" disabled={true} fullWidth margin="dense" {...register('oreord')} error={!!errors.oreord} />
                        <Typography variant="caption" color="error">{errors.oreord?.message}</Typography>
                    </Box>


                </Stack>

                <Box sx={{ width: '100%' }}>
                    <Controller
                        name="note"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <VersOreNoteAssist
                                textFieldId="note"
                                value={field.value || ''}
                                onChange={field.onChange}
                                error={!!errors.note}
                                helperText={errors.note?.message}
                            />
                        )}
                    />
                </Box>

                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                     <Box sx={{ width: '50%' }}>
                       <Controller
                                  name="luogo"
                                  control={control}
                                  render={({ field }) => (
                                    <Autocomplete
                                      options={LuoghiList}
                                      getOptionLabel={(option) => option.label}
                                      value={
                                        LuoghiList.find((opt) => opt.id === field.value) || null
                                      }
                                      onChange={(_, value) => {
                                        field.onChange(value ? value.id : '');
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} margin="dense" label="Seleziona Luogo" fullWidth />
                                      )}
                                    />
                                  )}
                                />
                        <Typography variant="caption" color="error">{errors.luogo?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '25%' }}>
                        <TextField id="km" label="Km" fullWidth margin="dense" {...register('km')} error={!!errors.km} />
                        <Typography variant="caption" color="error">{errors.km?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '25%' }}>
                        <TextField id="trasf" label="Trasf" fullWidth margin="dense" {...register('trasf')} error={!!errors.trasf} />
                        <Typography variant="caption" color="error">{errors.trasf?.message}</Typography>
                    </Box>
                </Stack>
            </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ marginTop: '15px' }}>
                <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                <Button id="save" type="submit" color="primary" variant="contained"
                        disabled={isCreatingVersOre}
                        startIcon={isCreatingVersOre ? <CircularProgress color="inherit" size={25} /> : null}
                        onClick={() => handleButtonClick('save')}>
                    SALVA
                </Button>
            </Stack>
        </form>

       {/*<Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ marginTop: '15px' }}>*/}
       {/*{codprog && <ReportProg key={codprog} codprogprop={codprog} />}*/}
       {/*</Stack>*/}


    </DialogContent>
</Dialog>
    <Dialog
      open={openReport}
      onClose={() => setOpenReport(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Report Nodi Progetto</DialogTitle>

      <DialogContent>
       <ReportProg key={watchIdProg} idprogprop={watchIdProg} />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenReport(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  </>


  );
};

export default AddVersOre;
